

<div class="w-100 h-100" *ngIf="!globalVariables.isPageSmall" [innerHTML]='html_desktop'></div>

<div class="w-100 h-100" *ngIf="globalVariables.isPageSmall" [innerHTML]='html_mobile'></div>
<!--
<div class="container-fluid h-100" style="padding: 0;">
  <div class="row no-gutters justify-content-center align-items-center h-100">
    <div class="col justify-content-center align-items-center d-flex">
      <div class="login-popup">
        <div (keyup.enter)="sendLogin()" class="login-container">
          <div class='profile-pic align-items-center mt-4'>
            <label>
              <img src='assets/icons/icon-user-color.png'>
            </label>
          </div>
          <form class="pb-2">
            <div class="form-group input-group-sm mb-1">
              <label for="username" class="pl-3 mb-0">
                <small>Usuario:</small>
              </label>
              <input type="username" autocomplete="username" class="form-control" id="username" name="username"
                style="font-size: 0.9rem !important;" [(ngModel)]='userName' required>
            </div>
            <div class="form-group mt-0 input-group-sm">
              <label for="password" class="pl-3 mb-0">
                <small>Contraseña:</small>
              </label>
              <input type="password" autocomplete="password" class="form-control" id="password" name="password"
                style="font-size: 0.9rem !important;" [(ngModel)]='password' required>
            </div>
          </form>

          <div class="row g-0 mt-2">
            <div class="w-100">
              <button type="button" class="btn btn-primary w-100" (click)="sendLogin()">Acceder</button>
            </div>
          </div>

          <br>
        </div>
      </div>
    </div>
    <div class="col-6">
      <div class="row no-gutters">
        <div class="col justify-content-center align-items-center d-flex">
          <div style="width: 60%;">
            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px" y="0px" viewBox="0 0 357.9 128.4" style="enable-background:new 0 0 357.9 128.4;"
              xml:space="preserve">
              <style type="text/css">
                .st0 {
                  fill: #40E0D0;
                }

                .st1 {
                  fill: url(#SVGID_1_);
                }

                .st2 {
                  fill: url(#SVGID_00000033361603086568800610000001206592766712702909_);
                }

                .st3 {
                  fill: url(#SVGID_00000014592029657740606310000003548722697478867350_);
                }

                .st4 {
                  fill: url(#SVGID_00000176026638214921583920000004626730004920034434_);
                }

                .st5 {
                  fill: url(#SVGID_00000111167049499176552330000018443230116380571314_);
                }

                .st6 {
                  fill: url(#SVGID_00000049915785060405607860000004983797017948811421_);
                }

                .st7 {
                  fill: url(#SVGID_00000129186182139647980090000014334830608988439194_);
                }

                .st8 {
                  font-family: 'MyriadPro-Regular';
                }

                .st9 {
                  font-size: 7.4354px;
                }
              </style>
              <g id="Capa_2_00000122686221705704982890000014556218092017234048_">
                <g id="Capa_1-2">
                  <path class="st0" d="M21.6,121c1-6.4-2.2-7.8-10.1-13.1c-2-1.3-3.2-3.4-3.3-5.8c0-2.6,2.1-4.7,4.7-4.7c0.1,0,0.2,0,0.3,0
               c4.6,0,7.8,5,9.8,7.7v-5.4c-2.4-3.3-5.2-6-9.7-6c-5,0-9.4,3.6-9,8.7c0,0.6,0.2,1.2,0.6,1.8c0.2,0.3,0.4,0.7,0.7,0.9
               C12.4,112.2,22.4,114.1,21.6,121z" />
                  <path class="st0" d="M1.5,100.2c-1,6.4,2.2,7.8,10.1,13.1c2,1.3,3.2,3.4,3.3,5.8c0,2.6-2.1,4.7-4.7,4.7c-0.1,0-0.2,0-0.3,0
               c-4.6,0-7.8-5-9.8-7.6v5.4c2.4,3.3,5.2,6.1,9.7,6.1c5,0,9.4-3.6,9-8.7c-0.1-0.6-0.2-1.2-0.6-1.8c-0.2-0.3-0.4-0.7-0.7-0.9
               C10.6,109,0.7,107.1,1.5,100.2z" />
                  <path class="st0" d="M40.5,110.3l-8.9-10.7l-0.1-6l11.4,13.6c0.2,0.2,0.5,0.2,0.7,0c0,0,0,0,0,0l11.2-13.6v6l-8.7,10.7
               c-0.5,0.5-0.8,1.1-1,1.7v15.6h-3.4V112C41.6,111.6,40.8,110.7,40.5,110.3z" />
                  <path class="st0" d="M333.3,110.3l-8.9-10.7l-0.1-6l11.4,13.6c0.2,0.2,0.5,0.2,0.7,0c0,0,0,0,0,0l11.2-13.6v6l-8.7,10.7
               c-0.5,0.5-0.8,1.1-1,1.7v15.6h-3.5V112C334.4,111.6,333.6,110.7,333.3,110.3z" />
                  <path class="st0" d="M63.5,127.6V93.6l23,25.2c0.1,0.1,0.2,0.1,0.3,0c0,0,0.1-0.1,0.1-0.1v-25h3.4v33.9l-22.9-24.9
               c-0.1-0.1-0.2-0.1-0.3,0c0,0-0.1,0.1-0.1,0.1v24.8L63.5,127.6z" />
                  <path class="st0" d="M253.7,127.6V93.6l23,25.2c0.1,0.1,0.2,0.1,0.3,0c0,0,0.1-0.1,0.1-0.1v-25h3.4v33.9l-23-24.9
               c-0.1-0.1-0.2-0.1-0.3,0c0,0-0.1,0.1-0.1,0.1v24.8L253.7,127.6z" />
                  <path class="st0" d="M132.2,104.6c-4.2-5.8-8.1-8.6-14.9-8.6c-8.1,0-14.8,6-14.8,14.7c0,8.4,6.4,14.6,15,14.6
               c4.7,0,9.2-1.6,14.7-8.7l-0.1,5.1c-3.5,4.4-8.7,6.7-14.9,6.7c-11.4,0-18.3-8-18.3-18s7.8-17.7,18.3-17.7c6.3,0,11.5,2.5,14.9,7.2
               L132.2,104.6z" />
                  <path class="st0" d="M142.4,93.5h3.4v13.7c0,0.3,0.2,0.6,0.6,0.6h16.2c0.3,0,0.6-0.3,0.6-0.6V93.5h3.4v34h-3.4v-15.9
               c0-0.3-0.3-0.6-0.6-0.6h-16.2c-0.3,0-0.6,0.3-0.6,0.6v15.9h-3.4V93.5z" />
                  <path class="st0" d="M191.5,112.4l7.5,9.8v5.4l-11.7-15.1H191.5z M183.3,111.7h-1.7c-0.2,0-0.3,0.1-0.3,0.3v15.6h-3.4V93.5h7.8
               c3.6,0,6.3,0.2,7.9,0.8c3.5,1.2,5.7,4.5,5.6,8.2c0.1,1.5-0.3,2.9-1,4.2c-1.8,3.6-5.2,4.9-10.8,4.9L183.3,111.7z M181.3,97.1V108
               c0,0.2,0.1,0.3,0.3,0.3l0,0c1.8,0,3.6,0.1,5.3,0.1c2.9,0,5.2-0.3,6.7-1.5c1.3-1.1,2-2.7,2-4.4c0-3.3-2.3-5.7-7.4-5.7h-6.7
               C181.5,96.8,181.3,96.9,181.3,97.1C181.3,97.1,181.3,97.1,181.3,97.1L181.3,97.1z" />
                  <path class="st0" d="M244,110.5c0,10-7.6,17.9-17.4,17.9c-10.1,0-17.4-8.2-17.4-17.7c0-10.2,7.6-18,17.1-18
               C236.4,92.6,244,100.3,244,110.5z M212.7,110.6c-0.2,7.7,5.8,14.2,13.6,14.4c0.1,0,0.2,0,0.3,0c7.7,0,14-6.1,14-14.6
               c0.2-7.8-6-14.3-13.8-14.5c-0.1,0-0.2,0-0.2,0C219.3,95.9,212.7,101.9,212.7,110.6L212.7,110.6z" />
                  <path class="st0" d="M292.3,93.6h3.4v34.1h-3.4V93.6z" />
                  <path class="st0" d="M301.1,96.9v-3.3h18.7v3.3h-7.2c-0.2,0-0.4,0.2-0.4,0.4v0v30.3h-3.4V97.3c0-0.2-0.2-0.4-0.4-0.4l0,0
               L301.1,96.9z" />

                  <radialGradient id="SVGID_1_" cx="178.37" cy="113.2345" r="75.5435" fx="178.37" fy="188.0571"
                    gradientTransform="matrix(1 0 0 -1.31 0 185.36)" gradientUnits="userSpaceOnUse">
                    <stop offset="0" style="stop-color:#004B79" />
                    <stop offset="0.76" style="stop-color:#009FE3" />
                  </radialGradient>
                  <path class="st1"
                    d="M213,39.5c0,0.5,0,1,0,1.5c-0.1,1.8-0.3,3.6-0.7,5.4c-1.8,8.5-6.6,16-13.7,21.1c-0.5,0.4-1.1,0.8-1.7,1.1
               c-1.3,0.8-2.6,1.6-4,2.2c-1.6,0.8-3.3,1.4-5,1.9c-0.4,0.1-0.9,0.2-1.4,0.4l-1.1,0.2c-4.5,1-9.2,1-13.8,0.1c-0.3-0.1-0.7-0.1-1-0.2
               c-0.5-0.1-1.1-0.2-1.6-0.4c-1.7-0.5-3.4-1.1-5-1.8c-1.6-0.7-3.1-1.5-4.5-2.4c-0.8-0.5-1.6-1.1-2.4-1.7
               c-8.2-6.3-13.2-15.9-13.6-26.2c0-0.4,0-0.9,0-1.3c0-2.7,0.3-5.4,0.9-8c0.4-1.7,0.9-3.3,1.5-4.9c0.8-2.1,1.9-4.1,3.1-6
               c10.4-16,31.8-20.6,47.9-10.2c2.8,1.8,5.3,4,7.5,6.6c2.5,2.9,4.6,6.3,6,9.9c0.6,1.6,1.1,3.2,1.5,4.9C212.7,34.4,213,37,213,39.5z" />

                  <radialGradient id="SVGID_00000005968098089830312170000003722155142120946319_" cx="163.0846"
                    cy="-212.5738" r="47.78" fx="142.374" fy="-212.5738"
                    gradientTransform="matrix(0.84 -0.54 -0.24 -0.37 50.28 54.88)" gradientUnits="userSpaceOnUse">
                    <stop offset="0" style="stop-color:#004B79" />
                    <stop offset="0.96" style="stop-color:#009FE3" />
                  </radialGradient>
                  <path style="fill:url(#SVGID_00000005968098089830312170000003722155142120946319_);" d="M272.9,38.1c-1.2,1.6-2.4,3.1-3.8,4.5
               c-6.8,7.4-17,15.1-29.2,21.4c-13,6.7-25.8,10.6-36.1,11.5c-1.6,0.2-3.2,0.2-4.7,0.2c-0.4,0-0.7,0-1.1,0c1.2-0.2,2.3-0.5,3.4-0.8
               c5.3-1.6,10.3-3.9,14.9-6.9c6.4-4,12.3-8.8,17.6-14.1c3.5-3.5,6.7-7.2,9.7-11.1c1.3-1.8,2.6-3.6,3.7-5.3c4.2-6.5,7-12.8,8.2-18.3
               c0.4-1.7,0.6-3.4,0.6-5.1c1.6-0.2,3.2-0.2,4.7-0.2c8.1,0,14,2.2,16.3,6.7S277.8,31.4,272.9,38.1z" />

                  <radialGradient id="SVGID_00000031915994919621324340000013693101808657214366_" cx="234.6172"
                    cy="-108.2678" r="54.67" fx="200.0755" fy="-108.2678"
                    gradientTransform="matrix(0.9936 -0.1129 -4.514256e-02 -0.3974 7.3576 44.8007)"
                    gradientUnits="userSpaceOnUse">
                    <stop offset="0" style="stop-color:#004B79" />
                    <stop offset="0.96" style="stop-color:#009FE3" />
                  </radialGradient>
                  <path style="fill:url(#SVGID_00000031915994919621324340000013693101808657214366_);" d="M244.8,82.3c-6.4,0.9-12.8,1.3-19.2,1.3
               c-14.4,0-26.6-2.4-33.7-6.6c0.9,0.1,1.8,0.2,2.6,0.2c1.5,0,3-0.2,4.5-0.4c0.4,0,0.7,0,1.1,0c1.5,0,3.1-0.1,4.7-0.2
               c10.3-0.9,23.1-4.8,36.1-11.5c12.2-6.3,22.4-13.9,29.2-21.4c1.3-1.4,2.6-3,3.8-4.5c14.2,2.1,23.9,7.1,24.9,14.1
               C300.3,65,276.2,78.1,244.8,82.3z" />

                  <radialGradient id="SVGID_00000036248156721513107810000001178222404376245156_" cx="107.8625"
                    cy="-279.9392" r="54.69" fx="93.0773" fy="-279.9392"
                    gradientTransform="matrix(0.72 -0.69 -0.28 -0.3 57.32 32.72)" gradientUnits="userSpaceOnUse">
                    <stop offset="0" style="stop-color:#004B79" />
                    <stop offset="0.96" style="stop-color:#009FE3" />
                  </radialGradient>
                  <path style="fill:url(#SVGID_00000036248156721513107810000001178222404376245156_);" d="M255.2,13c0,1.7-0.3,3.4-0.6,5.1
               c-1.2,5.5-4,11.8-8.2,18.3c-1.1,1.8-2.4,3.5-3.7,5.3c-3,3.9-6.2,7.6-9.7,11.1c-5.3,5.4-11.2,10.1-17.6,14.1
               c-4.6,3-9.6,5.3-14.9,6.9c-1.1,0.3-2.3,0.6-3.4,0.8c-1.5,0.3-3,0.4-4.5,0.4c-0.9,0-1.8-0.1-2.6-0.2c-0.8-0.1-1.6-0.3-2.4-0.6
               l1.1-0.2c0.5-0.1,0.9-0.2,1.4-0.4c1.7-0.5,3.4-1.1,5-1.9c1.4-0.6,2.7-1.4,4-2.2c0.6-0.4,1.1-0.7,1.7-1.1
               c7-5.1,11.9-12.6,13.6-21.1c0.4-1.8,0.6-3.6,0.7-5.4c0-0.5,0-1,0-1.5c0-2.5-0.3-5.1-0.8-7.6c-0.4-1.7-0.9-3.3-1.5-4.9
               c-1.4-3.6-3.4-7-5.9-9.9C219.5,6.7,233.2,0,242.8,0c3.8,0,7,1,9.2,3.3S255.3,8.9,255.2,13z" />

                  <radialGradient id="SVGID_00000085241769811941299270000000129075598336726433_" cx="-229.1658"
                    cy="24.0311" r="49.1944" fx="-256.3132" fy="24.0311"
                    gradientTransform="matrix(-0.71 -0.7 -0.3 0.31 -15.38 -129.43)" gradientUnits="userSpaceOnUse">
                    <stop offset="0" style="stop-color:#004B79" />
                    <stop offset="0.96" style="stop-color:#009FE3" />
                  </radialGradient>
                  <path style="fill:url(#SVGID_00000085241769811941299270000000129075598336726433_);" d="M169.8,74.5c-0.7,0.2-1.4,0.4-2.1,0.4
               c-0.9,0.1-1.8,0.2-2.6,0.2c-1.5,0-3-0.2-4.5-0.4c-1.2-0.2-2.3-0.5-3.4-0.8c-5.3-1.6-10.3-3.9-14.9-6.9c-6.4-4-12.3-8.8-17.6-14.1
               c-3.5-3.5-6.7-7.2-9.6-11.1c-1.3-1.8-2.6-3.6-3.7-5.3c-4.2-6.5-7-12.8-8.2-18.3c-0.4-1.7-0.6-3.4-0.7-5.1c-0.1-4,0.9-7.4,3.3-9.7
               s5.4-3.3,9.2-3.3c9.5,0,22.9,6.5,35.5,17.7c-1.1,1.3-2.1,2.6-3,4c-1.2,1.9-2.3,3.9-3.1,6c-0.6,1.6-1.2,3.2-1.5,4.9
               c-0.6,2.6-0.9,5.3-0.9,8c0,0.4,0,0.9,0,1.3c0.4,10.3,5.4,19.9,13.6,26.2c0.8,0.6,1.6,1.1,2.4,1.7c1.4,0.9,2.9,1.7,4.5,2.4
               c1.6,0.7,3.3,1.3,5,1.8c0.5,0.1,1,0.3,1.6,0.4C169.1,74.4,169.4,74.4,169.8,74.5z" />

                  <radialGradient id="SVGID_00000098919320965478554630000006750443812412677300_" cx="126.1475"
                    cy="31.9252" r="55.08" fx="156.651" fy="31.9252"
                    gradientTransform="matrix(0.9774 0.2113 7.819018e-02 -0.3616 -13.5531 46.2753)"
                    gradientUnits="userSpaceOnUse">
                    <stop offset="0" style="stop-color:#004B79" />
                    <stop offset="0.96" style="stop-color:#009FE3" />
                  </radialGradient>
                  <path style="fill:url(#SVGID_00000098919320965478554630000006750443812412677300_);" d="M165.7,77c-7.1,4.2-19.2,6.6-33.7,6.6
               c-6.4,0-12.8-0.5-19.2-1.3C81.4,78.1,57.3,65,58.9,53.2c0.9-7,10.6-12,24.9-14.1c1.2,1.6,2.4,3.1,3.8,4.5
               c6.8,7.4,17,15.1,29.2,21.4c13,6.7,25.8,10.6,36.1,11.5c1.6,0.2,3.2,0.2,4.7,0.2c0.4,0,0.7,0,1.1,0c1.5,0.3,3,0.4,4.5,0.4
               C163.9,77.2,164.8,77.1,165.7,77z" />

                  <radialGradient id="SVGID_00000124858535335836700040000014282460064330442370_" cx="137.255"
                    cy="228.7638" r="48.04" fx="164.5932" fy="228.7638"
                    gradientTransform="matrix(0.8509 0.5253 0.1996 -0.3233 -43.0009 46.5703)"
                    gradientUnits="userSpaceOnUse">
                    <stop offset="0" style="stop-color:#004B79" />
                    <stop offset="0.92" style="stop-color:#009FE3" />
                  </radialGradient>
                  <path style="fill:url(#SVGID_00000124858535335836700040000014282460064330442370_);" d="M159.6,75.7c-0.4,0-0.7,0-1.1,0
               c-1.5,0-3.1-0.1-4.7-0.2c-10.3-0.9-23.1-4.8-36.1-11.5C105.5,57.7,95.3,50,88.5,42.6c-1.3-1.4-2.6-3-3.8-4.5
               c-5-6.7-6.8-13-4.4-17.6s8.3-6.7,16.3-6.7c1.5,0,3.1,0.1,4.7,0.2c0,1.7,0.2,3.4,0.6,5.1c1.2,5.5,4,11.8,8.2,18.3
               c1.1,1.8,2.4,3.6,3.7,5.3c3,3.9,6.2,7.7,9.7,11.1c5.3,5.4,11.2,10.1,17.6,14.1c4.6,3,9.6,5.3,14.9,6.9
               C157.3,75.2,158.4,75.5,159.6,75.7z" />
                </g>
              </g>
              <text transform="matrix(1 0 0 1 351.3887 95.7637)" class="st0 st8 st9">R</text>
              <path class="st0" d="M357.9,93.5c0,2.6-2,4.6-4.5,4.6c-2.6,0-4.5-2.1-4.5-4.6c0-2.6,2-4.7,4.4-4.7C356,88.8,357.9,90.8,357.9,93.5z
            M349.8,93.5c-0.1,2,1.5,3.7,3.5,3.7c0,0,0.1,0,0.1,0c2,0,3.6-1.6,3.6-3.8c0.1-2-1.5-3.7-3.6-3.8c0,0,0,0-0.1,0
           C351.6,89.7,349.8,91.2,349.8,93.5L349.8,93.5z" />
            </svg>
          </div>
        </div>
      </div>
      
    </div>
  </div>

</div>
-->